import { render, staticRenderFns } from "./CardBrandsImages.vue?vue&type=template&id=3e0a9a0e"
import script from "./CardBrandsImages.vue?vue&type=script&lang=js"
export * from "./CardBrandsImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports